export default "__VITE_PUBLIC_ASSET__66b0e374__"